export default __webpack_public_path__ + "static/Porsche Cayenne-7ebdbf8a133ce97eb013d385912654f8.jpg";